import React from "react";

import { inject, observer } from "mobx-react";

import { PermissionsController } from "../../PermissionsController";
import { PermissionCheckbox } from "./PermissionCheckbox";
import { Button, Empty } from "antd";
import _ from "lodash";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faSortAsc, faSortDesc } from "@fortawesome/free-solid-svg-icons";

@inject("permissionsController", "store")
@observer
export class PermissionCard extends React.Component<{
  permissionsController?: PermissionsController;
}> {
  private renderUserRoutes = () => {
    const { userRoutesData } = this.props.permissionsController;

    if (userRoutesData.length === 0) {
      return <Empty key="empty" image={Empty.PRESENTED_IMAGE_SIMPLE} description="No permissions found for selected role" style={{ margin: "20px 0" }} />;
    }

    return userRoutesData.map((p) => {
      return (
        <div key={p._id} className="cardRow">
          <div className="cell" style={{ width: 250 }}>
            {p.name}
            {p.isNew && <span className="isNew">NEW</span>}
            {p.isUpdated && <span className="isUpdated">UPDATED</span>}
          </div>
          <div
            className="cell"
            style={{ width: 150 }}
            // onDoubleClick={() => {
            //   if (p.current) {
            //     p.past = false;
            //     p.current = false;
            //     p.future = false;
            //   } else {
            //     p.past = true;
            //     p.current = true;
            //     p.future = true;
            //   }
            // }}
          >
            {p.ref}
          </div>
          {/* <div className="cell">
            <PermissionCheckbox type="past" record={p} />
          </div> */}
          <div className="cell">
            <PermissionCheckbox type="current" record={p} />
          </div>
          {/* <div className="cell">
            <PermissionCheckbox type="future" record={p} />
          </div> */}
          <div className="cell" style={{ color: "#a9a9a9" }}>
            {p.notes}
          </div>
        </div>
      );
    });
  };

  private handleSortBy = (sortBy) => {
    const { sortPermissions } = this.props.permissionsController;

    if (!sortPermissions.direction) {
      sortPermissions.direction = "asc";
      sortPermissions.sortBy = sortBy;
    } else {
      if (sortPermissions.direction === "desc") {
        sortPermissions.direction = "";
        sortPermissions.sortBy = "";
      } else {
        sortPermissions.direction = "desc";
        sortPermissions.sortBy = sortBy;
      }
    }
  };

  private renderSortBtn = (sortBy) => {
    const { sortPermissions } = this.props.permissionsController;

    if (sortPermissions.sortBy === sortBy) {
      return (
        <Button
          type="primary"
          icon={_.get(sortPermissions, "direction", "") === "desc" ? <FontAwesomeIcon icon={faSortDesc} /> : <FontAwesomeIcon icon={faSortAsc} />}
          size="small"
          onClick={() => this.handleSortBy(sortBy)}
        />
      );
    }

    return <Button icon={<FontAwesomeIcon icon={faSort} />} size="small" onClick={() => this.handleSortBy(sortBy)} />;
  };

  public render() {
    const { selectedUserRole } = this.props.permissionsController;

    return (
      <div key={selectedUserRole._id} className="userRolesTable">
        {/* Header */}
        <div className="cardHeader">
          <div className="cell flex items-center" style={{ width: 250 }}>
            <b className="flex-1">Name</b>
            {this.renderSortBtn("name")}
          </div>
          <div className="cell flex items-center" style={{ width: 150 }}>
            <b className="flex-1">Ref</b>
            {this.renderSortBtn("ref")}
          </div>
          {/* <div className="cell">Past</div> */}
          <div className="cell">Enabled</div>
          {/* <div className="cell">Future</div> */}
          <div className="cell">Notes</div>
        </div>

        {/* Body */}
        {this.renderUserRoutes()}
      </div>
    );
  }
}
